<ag-memo-list
  [service]="companyApiService"
  [referenceId]="companyId"
  newText="新規INNER情報登録"
  title="INNER情報"
></ag-memo-list>
